import { render, staticRenderFns } from "./KrausSwitcherSmall.vue?vue&type=template&id=3c82d29c&lang=pug&"
import script from "./KrausSwitcherSmall.vue?vue&type=script&lang=js&"
export * from "./KrausSwitcherSmall.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports